export default __webpack_public_path__ + "static/media/lion.1015a79f.ogg";